import { Injectable } from "@angular/core";
import { CountriesService } from "../authorities/common/countries.service";
import { MICustomFunctionsParams } from "../../models/fields/custom-function-params";
import { ManufacturersFunctions } from "../authorities/common/manufacturers.service";
import { CommunicationService } from "../authorities/communication";
import { MICustomBookService } from "../authorities/common/custom-book/custom-book";
import { QuantityUnitCode } from "../authorities/common/quantiny-unitcode";
import { CommonFunctionService } from "../authorities/common/common";
import { EconomyService } from "../authorities/economy";
import { TransportService } from "../authorities/transport";

@Injectable({
    providedIn: 'root'
})
export class EventsCallBackService {

    constructor(
        private countriesService: CountriesService,
        private manufacturersService: ManufacturersFunctions,
        private communicationService: CommunicationService,
        private customBookService: MICustomBookService,
        private quantityUnitCode: QuantityUnitCode,
        private commonFunctionService: CommonFunctionService,
        private economyService: EconomyService,
        private transportService: TransportService

    ) {
    }
    eventsCallBack: Record<string, Function> = {
        "countriesOfMechesWithoutGroups": (customFunctionsParams: MICustomFunctionsParams) => {
            return this.countriesService.getCountryOfMechesByGroups(customFunctionsParams);
        },


        "updateManufacturerNameFromValues": (customFunctionsParams: MICustomFunctionsParams) => {
            return this.manufacturersService.updateManufacturerNameFromValues(customFunctionsParams);
        },
        "fillManufacturerList": (customFunctionsParams: MICustomFunctionsParams) => {
            return this.manufacturersService.fillManufacturerList(customFunctionsParams);
        },


        "getCustomItemFromList": (customFunctionsParams: MICustomFunctionsParams) => {
            return this.communicationService.getCustomItemFromList(customFunctionsParams);
        },
        "initCustomItemByPrice": (miCustomFunctionsParams: MICustomFunctionsParams) => {
            return this.communicationService.initCustomItemByPrice(miCustomFunctionsParams);
        },
        "initCustomItemList": (miCustomFunctionsParams: MICustomFunctionsParams) => {
            return this.customBookService.initCustomItemList(miCustomFunctionsParams);
        },

        "setEveryoneDeclareUnitCode": (customFunctionsParams: MICustomFunctionsParams) => {
            return this.quantityUnitCode.setEveryoneDeclareUnitCode(customFunctionsParams);
        },
        "getModelCodeList": this.noImplementFunction,
        "newValueAddedToModelCodeList": this.noImplementFunction,
        "setModelCodeChanged": this.noImplementFunction,
        "initCustomItemBySpecific": (miCustomFunctionsParams: MICustomFunctionsParams) => {
            return this.communicationService.initCustomItemBySpecific(miCustomFunctionsParams);
        },
        "sanitizeLink": (miCustomFunctionsParams: MICustomFunctionsParams) => {
            return this.commonFunctionService.sanitizeLink(miCustomFunctionsParams);
        },
        "uniqueProductList": () => {
            return this.economyService.uniqueProductList();
        },
        "getModelYear": (miCustomFunctionsParams: MICustomFunctionsParams) => {
            return this.transportService.getModelYear(miCustomFunctionsParams);
        },

    }

    noImplementFunction(functionName: string) {
        console.warn("no implement for function: " + functionName + " in MI")

    }
}
